@use "../../../../styles/Constants.scss" as Constants;
@use "../../../../styles/Colors.scss" as Colors;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;
$var-submit-action-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;

.work-request-form {

	&__contact-dropdown-item {
		display: flex;
		flex-direction: column;

		&__main {
			font-size: Constants.$val-fontSizeRegular;
		}

		&__secondary {
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-greyFontLight;
		}
	}

	&__submit-section {
		display: flex;
		align-items: center;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 2px solid Colors.$col-greyBackground;
		top: $var-submit-action-top-offset;
		position: sticky;

		& > * + * {
			margin-left: Constants.$val-spacing-xs;
		}

		&__hint {
			color: Colors.$col-greyFontLight;
			font-style: italic;
			flex: 1;
		}
	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
		z-index: 3;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;

		&__form-section {
			background-color: Colors.$col-white;
			box-shadow: $var-shadow;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l;

			&__title {
				text-transform: uppercase;
				color: Colors.$col-design-grey11;
				font-size: Constants.$val-fontSizeSmall;
				margin-bottom: Constants.$val-spacing-m;
			}

			:global([class^="_label_"]) + &__row {
				margin-top: Constants.$val-spacing-m;
			}

			&__row {
				display: grid;
				gap: Constants.$val-spacing-l;
				grid-template-columns: repeat(8, 1fr);

				&__column-1 {
					grid-column: span 1;
				}

				&__column-2 {
					grid-column: span 2;
				}

				&__column-4 {
					grid-column: span 4;
				}

				&__column-6 {
					grid-column: span 6;
				}

				&__column-8 {
					grid-column: span 8;
				}

				&__centered-column {
					display: flex;
					align-items: center;
				}
			}
		}
	}

	&__contact {
		background-color: Colors.$col-white;
		margin: (- Constants.$val-spacing-m) 0 (- Constants.$val-spacing-l) (- Constants.$val-spacing-l);
	}

	&__billing-information-title {
		padding-bottom: Constants.$val-spacing-m;
	}

	&__additional-contact-container {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		padding-bottom: Constants.$val-spacing-l;


		& > button {
			margin-top: Constants.$val-spacing-l;
		}
	}

	&__delete-button {
		margin-top: Constants.$val-spacing-m;

		& > [class^="icon-delete"] {
			color: Colors.$col-grey;
			font-size: Constants.$val-fontSizeBig;
			cursor: pointer;
			margin-top: calc(Constants.$val-spacing-l + Constants.$val-spacing-s);

			&:hover {
				color: Colors.$col-black;
			}
		}
	}

	&__additional-contact {
		margin: 0 0 (- Constants.$val-spacing-l) (- Constants.$val-spacing-l);
		background-color: Colors.$col-white;
		padding-top: Constants.$val-spacing-s;
		padding-bottom: Constants.$val-spacing-s;
	}

	&__waste-types {
		padding: Constants.$val-spacing-m 0;
	}

	&__radio-group {
		padding-bottom: Constants.$val-spacing-m;
	}

	&__tab {
		display: flex;
		gap: Constants.$val-spacing-xs;
		align-items: center;

		& > [class^="icon-warning"] {
			color: Colors.$col-canceledRed;
			font-size: Constants.$val-fontSizeBig;

		}
	}

	&__job-hazard-assessment-status-error {
		padding-bottom: Constants.$val-spacing-m;
		color: Colors.$col-canceledRed;
		font-style: italic;
	}

	&__add-field-button {
		width: fit-content;
		color: Colors.$col-blue;
		cursor: pointer;
		display: flex;
		align-items: center;
		margin-top: Constants.$val-spacing-m;

		& [class^="icon-plus"] {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-s;
		}
		&:hover {
			color: Colors.$col-darkBlueBorder;
		}
	}

	&__deliverables {
		margin-bottom: Constants.$val-spacing-m;
	}

	&__trucks-and-equipment {

		&__column {
			display: flex;
			flex-direction: column;
			gap: Constants.$val-spacing-s;
		}

		&__number-of-employees {
			display: flex;
			align-items: center;
			padding: Constants.$val-spacing-l 0;

			&__field-column {
				& > div {
					margin-bottom: 0 !important;
				}
			}

			&__field {
				border: 0 !important;
				border-bottom: 1px solid Colors.$col-greyMid !important;
				width: 100px !important;
			}
		}

		&__additional-field {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: Constants.$val-spacing-s;

			& > div {
				margin-bottom: 0 !important;
			}

			&__name {
				background-color: red;
				margin: 0 !important;
			}

			&__delete-button {
				& > [class^="icon-delete"] {
					color: Colors.$col-grey;
					font-size: Constants.$val-fontSizeBig;
					cursor: pointer;

					&:hover {
						color: Colors.$col-black;
					}
				}
			}
		}
	}

}
